<template>
    <div class="container-center">
        <div class="help-list">
            <template>
                <el-table
                    :data="tableData"
                    border
                    style="width: 100%">
                    <el-table-column
                        type="index"
                        width="180"
                        label="序号">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="文档名称"
                        width="180">
                        <template slot-scope="scope">
                            <a class="vlink" :href="`${baseUrl}rest/api/sftp/download?name=${scope.row.fileOldName}&path=${scope.row.filePath}`">
                                {{ scope.row.name }}
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="issueDate"
                        label="时间">
                    </el-table-column>
                </el-table>
            </template>

        </div>

        <div class="block">
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="pager.pageSize"
                :current-page="pager.pageNum"
                :total="pager.total"
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next"
                background
                >
            </el-pagination>
        </div>

    </div><!-- container-center -->

</template>

<script type="text/babel">
import util from '@/util'
import banner from '@/assets/imgs/banner_invite.png'

export default {
    name: 'help-list',
    data () {
        return {
            baseUrl: util.baseUrl,
            tableData: [],
            pager:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            }

        }
    },
    methods: {
        getHelpList () {
            this.$http.post('/rest/api/help/file/list',{
                    pageNum: this.pager.pageNum,
                    pageSize: this.pager.pageSize
                }
            ).then((res)=>{
                if(res.data.result) {
                    this.tableData = res.data.value.list;
                    this.pager.total = res.data.value.count;
                    this.pager.pageNum = res.data.value.pageNo;
                }
            })
        },
        handleCurrentChange (page) {
            this.pager.pageNum = page;
            this.getHelpList();
        }

    },
    created(){
        this.$root.navs = [{name:'帮助中心',path:'/help'}];
        this.$root.headImage.src = banner;
    },
    mounted () {
        this.getHelpList();
    }
}

</script>

<style scoped lang="postcss">
@import '../../../assets/common.css';
    .help-list {
        margin: 24px 0;
    }
    .help-list .vlink {
        text-decoration: none;
        color: var(--cTxt2);
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/help/Help.vue